import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import {
  Box,
  Button,
  Grid,
  TextField,
  Divider,
  Tooltip,
} from "@mui/material";
import { Helmet } from "react-helmet";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import ProgrammingLang from "./ProgrammingLang";
import Applications from "./Applications";
import Tools from "./Tools";
import SystemTools from "./Systemtools";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  stepper: {
    color: "green",
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "10px 30px",
    paddingLeft: 10,
  },

  
}));


export default function InstanceConfig(props) {
  const { 
    instancetype, 
    formFields,
    setFormFields, 
    linuxsingleselectedapp,
    setLinuxsingleselectedapp,
    setProgrammingapps, setSystemtools, setNormalapps, setDevopsapps, setDevopsport, setNormalport
  } = props;    


  const classes = useStyles();

  const handleChangeInput = (e, index) => {
    const { name, value } = e.target;
    const list = [...formFields];
    list[index][name] = value;
    setFormFields(list);
  };

  const handleInstancetypeChangeInput = (e, index, selectedTitle) => {
    const { name, value } = e.target;
    const list = [...formFields];
    const ins_type_data = instancetype.find(instancetype => instancetype.title === value)
    if (selectedTitle !== undefined) {
      list[index]["instance_title"] = selectedTitle;
      list[index][name] = ins_type_data.instance_type;
    }
    setFormFields(list);
    // console.log("formFields", formFields);
   };

  const handleRemoveForm = () => {
    const lastIndex = formFields.length - 1;
    const list = [...formFields];
    list.splice(lastIndex, 1);
    setFormFields(list);
    const nameJsonStr = linuxsingleselectedapp;
    delete nameJsonStr[lastIndex];
    setLinuxsingleselectedapp(nameJsonStr);
  };

  const handleAddForm = () => {
    if (formFields.length < 5) {
      const newAddValue = {
        instance_type: "",
        ostype: "linux",
        linux_type: "",
        windows_type: "",
        instance_storage: "",
        multi_select: false
      };
      setFormFields([...formFields, newAddValue]);
    }  
  };


  
  var currentTime = new Date();
  var currentOffset = currentTime.getTimezoneOffset();
  var ISTOffset = 330; 
  var ISTTime = new Date(
    currentTime.getTime() + (ISTOffset + currentOffset) * 60000
  );

  return (
    <React.Fragment>
      <Helmet>
        <title>LabAsService</title>
      </Helmet>
              <Box sx={{ pb: 0, pt: 0 }}>
                <div className={classes.buttons}>
                  <Tooltip title="Add a new server configuration">
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={() => handleAddForm()}
                      sx={{ borderRadius: '50px' }}
                    >
                      ADD
                    </Button>
                  </Tooltip>
                </div>
              </Box>
              {formFields.length > 0 ? (
                <React.Fragment>
                  <Typography variant="h6" gutterBottom>
                  {formFields.length} machines are added ( Maximum 5 machines are allowed )
                  </Typography>
                  {formFields.map((e, index) => {
                    const serverIndex = index + 1;
                    return (
                      <div key={index}>
                        <Box sx={{ m: 2, border: "1px solid dark" }}>
                          <Accordion
                            style={{ border: "1px solid rgba(0, 0, 0, .125)" }}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1c-content"
                              id="panel1c-header"
                            >
                           
                              <Typography variant="h6">
                                Machine-{serverIndex}
                              </Typography>
                            
                            </AccordionSummary>
                            <AccordionDetails>
                            
                              <Grid container spacing={4}>
                              <Grid item xs={6}>
                                  <TextField
                                    fullWidth
                                    label="OS-Type"
                                    name={`ostype`}
                                    id={`ostype`}
                                    onChange={(e) =>
                                      handleChangeInput(e, index)
                                    }
                                    value={e.ostype}                            
                                    required
                                    select
                                    SelectProps={{ native: true }}
                                    autoComplete="name"
                                  >
                                    {" "}
                                    <option key="linux" value="linux">
                                      Linux
                                    </option>
                                    <option key="windows" value="windows">
                                      Windows
                                    </option>
                                  </TextField>
                                </Grid>
                                {formFields[index].ostype === "linux" ?                                
                                 (
                                  <Grid item xs={6}>
                                      <TextField                                         
                                        fullWidth
                                        label="Linux-Type"
                                        name={`linux_type`}
                                        id={`linux_type`}
                                        onChange={(e) =>
                                          handleChangeInput(e, index)
                                        }
                                        value={e.linux_type}
                                        required
                                        select
                                        SelectProps={{ native: true }}
                                        autoComplete="name"
                                      >
                                        {" "}
                                        <option key="" value=""></option>
                                        <option key="centos8" value="centos8">
                                          Centos8
                                        </option>
                                        <option key="rocky8" value="rocky8">
                                          Rocky8
                                        </option>
                                        <option key="rocky9" value="rocky9">
                                          Rocky9
                                        </option>
                                        <option key="alma8" value="alma8">
                                          Alma8
                                        </option>
                                        <option key="alma9" value="alma9">
                                          Alma9
                                        </option>
                                        {/* <option key="ubuntu18" value="ubuntu18">
                                          Ubuntu18
                                        </option> */}
                                        <option key="ubuntu20" value="ubuntu20">
                                          Ubuntu20
                                        </option>
                                        <option key="ubuntu22" value="ubuntu22">
                                          Ubuntu22
                                        </option>
                                        <option key="ubuntu24" value="ubuntu24">
                                          Ubuntu24
                                        </option>
                                      </TextField>
                                    </Grid>
                                )
                                :
                                ( 
                                  <Grid item xs={6}>
                                      <TextField                                         
                                        fullWidth
                                        label="Windows-Type"
                                        name={`windows_type`}
                                        id={`windows_type`}
                                        onChange={(e) =>
                                          handleChangeInput(e, index)
                                        }
                                        value={e.windows_type}
                                        required
                                        select
                                        SelectProps={{ native: true }}
                                        autoComplete="name"
                                      >
                                        {" "}
                                        <option key="" value=""> </option>
                                        <option key="windows10" value="windows10">
                                          Windows10
                                        </option>
                                        <option key="windows11" value="windows11">
                                          Windows11
                                        </option>
                                        <option key="windows2016" value="windows2016">
                                          Windows2016
                                        </option>
                                        <option key="windows2019" value="windows2019">
                                          Windows2019
                                        </option>
                                        <option key="windows2022" value="windows2022">
                                          Windows2022
                                        </option>
                                        
                                      </TextField>
                                    </Grid>
                                  )}  
                                <Grid item xs={6}>
                                  <TextField
                                    fullWidth
                                    label="Instance Type"
                                    name={`instance_type`}
                                    id={`instance_type`}
                                    // onChange={(e) =>
                                    //   handleChangeInput(e, index)
                                    // }
                                    onChange={(e) =>
                                      handleInstancetypeChangeInput(e, index, e.target.options[e.target.selectedIndex].text)
                                    }
                                    value={e.instance_title}
                                    required
                                    autoComplete="name"
                                    select
                                    SelectProps={{ native: true }}
                                  >
                                    {" "}
                                    <option key="" value=""></option>
                                    {instancetype.map((instancetype) => {
                                      return (
                                        <React.Fragment>
                                          <option  key={instancetype.title}
                                            value={instancetype.instance_title}
                                          >
                                            {instancetype.title}
                                          </option>
                                        </React.Fragment>
                                      );
                                    })}
                                  </TextField>
                                </Grid>
                                <Grid item xs={6}>
                                <TextField
                                      fullWidth
                                      // label="Storage"
                                      name={`instance_storage`}
                                      id={`instance_storage`}
                                      onChange={(e) => handleChangeInput(e, index)}
                                      value={e.instance_storage}
                                      required
                                      select
                                      SelectProps={{ native: true }}
                                      autoComplete="name"
                                    >
                                      <option value="">Select Storage</option>

                                      {( formFields[index].ostype === "windows" && (formFields[index].windows_type === "windows10" || formFields[index].windows_type === "windows11")
                                        ) ? (
                                        <>
                                          <option key="127" value="127">127</option>
                                          <option key="250" value="250">250</option>
                                          <option key="500" value="500">500</option>
                                          <option key="1000" value="1000">1000</option>
                                        </>
                                      ) : (
                                        <>
                                          <option key="30" value="30">30</option>
                                          <option key="60" value="60">60</option>
                                          <option key="125" value="125">125</option>
                                          <option key="250" value="250">250</option>
                                          <option key="500" value="500">500</option>
                                          <option key="1000" value="1000">1000</option>
                                        </>
                                      )}
                                    </TextField>
                                </Grid>
                                {formFields[index].ostype === "linux" ? (
                                  <React.Fragment>                                  
                                    {formFields[index].linux_type ===
                                    "centos7" ? (
                                      <Grid item xs={12}>
                                        <Grid container spacing={4}>
                                          <Grid item xs={6}>
                                            <Applications
                                              OSTYPE="centos7"
                                              appsetFormFields={setNormalapps}
                                              appfieldIndex={index}
                                              setNormalport={setNormalport}
                                            />
                                          </Grid>
                                          <Grid item xs={6}>
                                            <ProgrammingLang
                                              OSTYPE="centos7"
                                              appsetFormFields={
                                                setProgrammingapps
                                              }
                                              appfieldIndex={index}
                                            />
                                          </Grid>
                                          <Grid item xs={6}>
                                          <SystemTools 
                                            OSTYPE="centos7"
                                            appsetFormFields={
                                              setSystemtools
                                            }
                                            appfieldIndex={index}                                          
                                          />
                                          </Grid>
                                          <Grid item xs={6}>
                                            <Tools
                                              OSTYPE="centos7"
                                              appsetFormFields={setDevopsapps}
                                              appfieldIndex={index}
                                              setDevopsport={setDevopsport}
                                            />
                                          </Grid>                                                                                    
                                        </Grid>
                                      </Grid>
                                    ) : formFields[index].linux_type ===
                                    "centos8" ? (
                                      <Grid item xs={12}>
                                        <Grid container spacing={4}>
                                          <Grid item xs={6}>
                                            <Applications
                                              OSTYPE="centos8"
                                              appsetFormFields={setNormalapps}
                                              appfieldIndex={index}
                                              setNormalport={setNormalport}
                                            />
                                          </Grid>
                                          <Grid item xs={6}>
                                            <ProgrammingLang
                                              OSTYPE="centos8"
                                              appsetFormFields={
                                                setProgrammingapps
                                              }
                                              appfieldIndex={index}
                                            />
                                          </Grid>
                                          <Grid item xs={6}>
                                          <SystemTools 
                                            OSTYPE="centos8"
                                            appsetFormFields={
                                              setSystemtools
                                            }
                                            appfieldIndex={index}                                          
                                          />
                                          </Grid>
                                          <Grid item xs={6}>
                                            <Tools
                                              OSTYPE="centos8"
                                              appsetFormFields={setDevopsapps}
                                              appfieldIndex={index}
                                              setDevopsport={setDevopsport}
                                            />
                                          </Grid>                                                                                    
                                        </Grid>
                                      </Grid>
                                    )
                                    : formFields[index].linux_type === 'ubuntu18' ?
                                    (
                                     <Grid item xs={12}>
                                       <Grid container spacing={4}>
                                         <Grid item xs={6}>
                                           <Applications
                                             OSTYPE="ubuntu18"
                                             appsetFormFields={setNormalapps}
                                             appfieldIndex={index}
                                             setNormalport={setNormalport}
                                           />
                                         </Grid>
                                         <Grid item xs={6}>
                                           <ProgrammingLang
                                             OSTYPE="ubuntu18"
                                             appsetFormFields={
                                               setProgrammingapps
                                             }
                                             appfieldIndex={index}
                                           />
                                         </Grid>
                                         <Grid item xs={6}>
                                         <SystemTools 
                                           OSTYPE="ubuntu18"
                                           appsetFormFields={
                                             setSystemtools
                                           }
                                           appfieldIndex={index}                                          
                                         />
                                         </Grid>
                                         <Grid item xs={6}>
                                           <Tools
                                             OSTYPE="ubuntu18"
                                             appsetFormFields={setDevopsapps}
                                             appfieldIndex={index}
                                             setDevopsport={setDevopsport}
                                           />
                                         </Grid>                                          
                                       </Grid>
                                     </Grid>
                                   ) 
                                   : formFields[index].linux_type === 'ubuntu20' ?
                                    (
                                     <Grid item xs={12}>
                                       <Grid container spacing={4}>
                                         <Grid item xs={6}>
                                           <Applications
                                             OSTYPE="ubuntu20"
                                             appsetFormFields={setNormalapps}
                                             appfieldIndex={index}
                                             setNormalport={setNormalport}
                                           />
                                         </Grid>
                                         <Grid item xs={6}>
                                           <ProgrammingLang
                                             OSTYPE="ubuntu20"
                                             appsetFormFields={
                                               setProgrammingapps
                                             }
                                             appfieldIndex={index}
                                           />
                                         </Grid>
                                         <Grid item xs={6}>
                                         <SystemTools 
                                           OSTYPE="ubuntu20"
                                           appsetFormFields={
                                             setSystemtools
                                           }
                                           appfieldIndex={index}                                          
                                         />
                                         </Grid>
                                         <Grid item xs={6}>
                                           <Tools
                                             OSTYPE="ubuntu20"
                                             appsetFormFields={setDevopsapps}
                                             appfieldIndex={index}
                                             setDevopsport={setDevopsport}
                                           />
                                         </Grid>                                          
                                       </Grid>
                                     </Grid>
                                   ) : formFields[index].linux_type ===
                                   "rocky8" ? (
                                     <Grid item xs={12}>
                                       <Grid container spacing={4}>
                                         <Grid item xs={6}>
                                           <Applications
                                             OSTYPE="rocky8"
                                             appsetFormFields={setNormalapps}
                                             appfieldIndex={index}
                                             setNormalport={setNormalport}
                                           />
                                         </Grid>
                                         <Grid item xs={6}>
                                           <ProgrammingLang
                                             OSTYPE="rocky8"
                                             appsetFormFields={
                                               setProgrammingapps
                                             }
                                             appfieldIndex={index}
                                           />
                                         </Grid>
                                         <Grid item xs={6}>
                                           <SystemTools
                                             OSTYPE="rocky8"
                                             appsetFormFields={setSystemtools}
                                             appfieldIndex={index}
                                             setNormalport={setNormalport}
                                           />
                                         </Grid>
                                         <Grid item xs={6}>
                                           <Tools
                                             OSTYPE="rocky8"
                                             appsetFormFields={setDevopsapps}
                                             appfieldIndex={index}
                                             setDevopsport={setDevopsport}
                                             // setDevopsport={setDevopsport}
                                           />
                                         </Grid>
                                       </Grid>
                                     </Grid>
                                   ) : formFields[index].linux_type ===
                                   "rocky9" ? (
                                     <Grid item xs={12}>
                                       <Grid container spacing={4}>
                                         <Grid item xs={6}>
                                           <Applications
                                             OSTYPE="rocky9"
                                             appsetFormFields={setNormalapps}
                                             appfieldIndex={index}
                                             setNormalport={setNormalport}
                                           />
                                         </Grid>
                                         <Grid item xs={6}>
                                           <ProgrammingLang
                                             OSTYPE="rocky9"
                                             appsetFormFields={
                                               setProgrammingapps
                                             }
                                             appfieldIndex={index}
                                           />
                                         </Grid>
                                         <Grid item xs={6}>
                                           <SystemTools
                                             OSTYPE="rocky9"
                                             appsetFormFields={setSystemtools}
                                             appfieldIndex={index}
                                             setNormalport={setNormalport}
                                           />
                                         </Grid>
                                         <Grid item xs={6}>
                                           <Tools
                                             OSTYPE="rocky9"
                                             appsetFormFields={setDevopsapps}
                                             appfieldIndex={index}
                                             setDevopsport={setDevopsport}
                                             // setDevopsport={setDevopsport}
                                           />
                                         </Grid>
                                       </Grid>
                                     </Grid>
                                   ) : formFields[index].linux_type ===
                                   "alma8" ? (
                                     <Grid item xs={12}>
                                       <Grid container spacing={4}>
                                         <Grid item xs={6}>
                                           <Applications
                                             OSTYPE="alma8"
                                             appsetFormFields={setNormalapps}
                                             appfieldIndex={index}
                                             setNormalport={setNormalport}
                                           />
                                         </Grid>
                                         <Grid item xs={6}>
                                           <ProgrammingLang
                                             OSTYPE="alma8"
                                             appsetFormFields={
                                               setProgrammingapps
                                             }
                                             appfieldIndex={index}
                                           />
                                         </Grid>
                                         <Grid item xs={6}>
                                           <SystemTools
                                             OSTYPE="alma8"
                                             appsetFormFields={setSystemtools}
                                             appfieldIndex={index}
                                             setNormalport={setNormalport}
                                           />
                                         </Grid>
                                         <Grid item xs={6}>
                                           <Tools
                                             OSTYPE="alma8"
                                             appsetFormFields={setDevopsapps}
                                             appfieldIndex={index}
                                             setDevopsport={setDevopsport}
                                             // setDevopsport={setDevopsport}
                                           />
                                         </Grid>
                                       </Grid>
                                     </Grid>
                                   ) : formFields[index].linux_type ===
                                   "alma9" ? (
                                     <Grid item xs={12}>
                                       <Grid container spacing={4}>
                                         <Grid item xs={6}>
                                           <Applications
                                             OSTYPE="alma9"
                                             appsetFormFields={setNormalapps}
                                             appfieldIndex={index}
                                             setNormalport={setNormalport}
                                           />
                                         </Grid>
                                         <Grid item xs={6}>
                                           <ProgrammingLang
                                             OSTYPE="alma9"
                                             appsetFormFields={
                                               setProgrammingapps
                                             }
                                             appfieldIndex={index}
                                           />
                                         </Grid>
                                         <Grid item xs={6}>
                                           <SystemTools
                                             OSTYPE="alma9"
                                             appsetFormFields={setSystemtools}
                                             appfieldIndex={index}
                                             setNormalport={setNormalport}
                                           />
                                         </Grid>
                                         <Grid item xs={6}>
                                           <Tools
                                             OSTYPE="alma9"
                                             appsetFormFields={setDevopsapps}
                                             appfieldIndex={index}
                                             setDevopsport={setDevopsport}
                                             // setDevopsport={setDevopsport}
                                           />
                                         </Grid>
                                       </Grid>
                                     </Grid>
                                   ) : formFields[index].linux_type ===
                                   "ubuntu24" ? (
                                     <Grid item xs={12}>
                                       <Grid container spacing={4}>
                                         <Grid item xs={6}>
                                           <Applications
                                             OSTYPE="ubuntu24"
                                             appsetFormFields={setNormalapps}
                                             appfieldIndex={index}
                                             setNormalport={setNormalport}
                                           />
                                         </Grid>
                                         <Grid item xs={6}>
                                           <ProgrammingLang
                                             OSTYPE="ubuntu24"
                                             appsetFormFields={
                                               setProgrammingapps
                                             }
                                             appfieldIndex={index}
                                           />
                                         </Grid>
                                         <Grid item xs={6}>
                                           <SystemTools
                                             OSTYPE="ubuntu24"
                                             appsetFormFields={setSystemtools}
                                             appfieldIndex={index}
                                             setNormalport={setNormalport}
                                           />
                                         </Grid>
                                         <Grid item xs={6}>
                                           <Tools
                                             OSTYPE="ubuntu24"
                                             appsetFormFields={setDevopsapps}
                                             appfieldIndex={index}
                                             setDevopsport={setDevopsport}
                                             // setDevopsport={setDevopsport}
                                           />
                                         </Grid>
                                       </Grid>
                                     </Grid>
                                   )
                                   : 
                                   (
                                    <Grid item xs={12}>
                                      <Grid container spacing={4}>
                                        <Grid item xs={6}>
                                          <Applications
                                            OSTYPE="ubuntu22"
                                            appsetFormFields={setNormalapps}
                                            appfieldIndex={index}
                                            setNormalport={setNormalport}
                                          />
                                        </Grid>
                                        <Grid item xs={6}>
                                          <ProgrammingLang
                                            OSTYPE="ubuntu22"
                                            appsetFormFields={
                                              setProgrammingapps
                                            }
                                            appfieldIndex={index}
                                          />
                                        </Grid>
                                        <Grid item xs={6}>
                                        <SystemTools 
                                          OSTYPE="ubuntu22"
                                          appsetFormFields={
                                            setSystemtools
                                          }
                                          appfieldIndex={index}                                          
                                        />
                                        </Grid>
                                        <Grid item xs={6}>
                                          <Tools
                                            OSTYPE="ubuntu22"
                                            appsetFormFields={setDevopsapps}
                                            appfieldIndex={index}
                                            setDevopsport={setDevopsport}
                                          />
                                        </Grid>                                          
                                      </Grid>
                                    </Grid>
                                  )}
                                  </React.Fragment>
                                ) : (
                                  <React.Fragment>
                                    {formFields[index].windows_type ===
                                      "windows2016" ? (
                                        <Grid item xs={12}>
                                          <Grid container spacing={4}>
                                            <Grid item xs={6}>
                                              <Applications
                                                OSTYPE="windows2016"
                                                appsetFormFields={setNormalapps}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <ProgrammingLang
                                                OSTYPE="windows2016"
                                                appsetFormFields={
                                                  setProgrammingapps
                                                }
                                                appfieldIndex={index}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <SystemTools
                                                OSTYPE="windows2016"
                                                appsetFormFields={setSystemtools}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      ) : formFields[index].windows_type === "windows2019" ?
                                    (
                                     <Grid item xs={12}>
                                      <Grid container spacing={4}>
                                        <Grid item xs={12} sm={4} md={3}>
                                          <Applications
                                            OSTYPE="windows2019"
                                            appsetFormFields={setNormalapps}
                                            appfieldIndex={index}
                                            setNormalport={setNormalport}
                                          />
                                        </Grid>
                                        <Grid item xs={12} sm={4} md={4}>
                                          <ProgrammingLang
                                            OSTYPE="windows2019"
                                            appsetFormFields={
                                              setProgrammingapps
                                            }
                                            appfieldIndex={index}
                                          />
                                        </Grid>
                                        <Grid item xs={12} sm={4} md={4}>
                                          <SystemTools 
                                            OSTYPE="windows2019"
                                            appsetFormFields={
                                              setSystemtools
                                            }
                                            appfieldIndex={index}                                          
                                          />
                                        </Grid>                                        
                                      </Grid>
                                    </Grid>
                                  ) : formFields[index].windows_type === "windows10" ?
                                  (
                                   <Grid item xs={12}>
                                    <Grid container spacing={4}>
                                      <Grid item xs={12} sm={4} md={3}>
                                        <Applications
                                          OSTYPE="windows10"
                                          appsetFormFields={setNormalapps}
                                          appfieldIndex={index}
                                          setNormalport={setNormalport}
                                        />
                                      </Grid>
                                      <Grid item xs={12} sm={4} md={4}>
                                        <ProgrammingLang
                                          OSTYPE="windows10"
                                          appsetFormFields={
                                            setProgrammingapps
                                          }
                                          appfieldIndex={index}
                                        />
                                      </Grid>
                                      <Grid item xs={12} sm={4} md={4}>
                                        <SystemTools 
                                          OSTYPE="windows10"
                                          appsetFormFields={
                                            setSystemtools
                                          }
                                          appfieldIndex={index}                                          
                                        />
                                        </Grid>                                        
                                    </Grid>
                                  </Grid>
                                ) : formFields[index].windows_type === "windows11" ?
                                  (
                                   <Grid item xs={12}>
                                    <Grid container spacing={4}>
                                      <Grid item xs={12} sm={4} md={3}>
                                        <Applications
                                          OSTYPE="windows11"
                                          appsetFormFields={setNormalapps}
                                          appfieldIndex={index}
                                          setNormalport={setNormalport}
                                        />
                                      </Grid>
                                      <Grid item xs={12} sm={4} md={4}>
                                        <ProgrammingLang
                                          OSTYPE="windows11"
                                          appsetFormFields={
                                            setProgrammingapps
                                          }
                                          appfieldIndex={index}
                                        />
                                      </Grid>
                                      <Grid item xs={12} sm={4} md={4}>
                                        <SystemTools 
                                          OSTYPE="windows11"
                                          appsetFormFields={
                                            setSystemtools
                                          }
                                          appfieldIndex={index}                                          
                                        />
                                        </Grid>                                        
                                    </Grid>
                                  </Grid>
                                ) : (<Grid item xs={12}>
                                      <Grid container spacing={4}>
                                        <Grid item xs={12} sm={4} md={3}>
                                          <Applications
                                            OSTYPE="windows2022"
                                            appsetFormFields={setNormalapps}
                                            appfieldIndex={index}
                                            setNormalport={setNormalport}
                                          />
                                        </Grid>
                                        <Grid item xs={12} sm={4} md={4}>
                                          <ProgrammingLang
                                            OSTYPE="windows2022"
                                            appsetFormFields={
                                              setProgrammingapps
                                            }
                                            appfieldIndex={index}
                                          />
                                        </Grid>
                                        <Grid item xs={12} sm={4} md={4}>
                                          <SystemTools 
                                            OSTYPE="windows2022"
                                            appsetFormFields={
                                              setSystemtools
                                            }
                                            appfieldIndex={index}                                          
                                          />
                                        </Grid>                                        
                                      </Grid>
                                    </Grid>
                                  )} 
                                  </React.Fragment>
                                )}                               
                              </Grid>
                              
                            </AccordionDetails>
                            <Divider />
                          </Accordion>
                        </Box>
                      </div>
                    );
                  })}
                  
                  <div className={classes.buttons}>
                    <Tooltip title="Delete the last server configuration">
                      <span>
                        <IconButton
                          aria-label="delete"
                          id="delete"
                          onClick={() => handleRemoveForm()}
                          style={{
                            padding: "10px",
                            color: "#e68383",
                            borderRadius: '50px'
                          }}
                        >
                          <DeleteIcon
                            color="secondary"
                            variant="contained"
                          />
                        </IconButton>
                      </span>
                    </Tooltip>
                  </div>                  
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Box
                    sx={{
                      pb: 2,
                      pt: 2,
                      m: 2,
                      color: "#000000",
                      backgroundColor: "#e7e7e7",
                      border: "1px solid #2d5e6e",
                      bordercolor: "error.main",
                      paddingTop: 2,
                      paddingLeft: 2,
                      paddingRight: 2,
                      paddingBottom: 2,
                      textAlignLast: "center",
                    }}
                  >
                    <Typography variant="h6">+ Add the server...</Typography>
                  </Box>
                </React.Fragment>
              )}
    </React.Fragment>
  );
}